import { PromiseAllSettledStatus, PromiseAllSettledStatusType } from 'services/constants';

export const checkIsApiCallFulfilled = (status: PromiseAllSettledStatusType) => {
  return status === PromiseAllSettledStatus.Fulfilled;
};
